import React from 'react';
import { WhatIsBit } from '@teambit/bit.content.what-is-bit';

export const tags = [
  'components',
  'software',
  'composable',
  'component-driven',
  'collaboration',
  'development',
  'design',
  'product',
  'architecture',
  'compounding',
];

export const abstract = 'Bit is an open source toolchain for component-driven software';

export default function Docs() {
  return <WhatIsBit />;
}
